import cc from 'classcat';

import Link from '../../Link';
import Profile from '../Profile';

import { enhance } from './enhancers.js';
import styles from './styles.module.scss';

const LoginStatus = ({ product, className, isLoggedIn }) => (
  <div className={cc([styles.container, className])}>
    {!isLoggedIn && (
      <Link
        id="navigation-login"
        key="login-link"
        theme={product}
        to={`/login?product=${product}`}
      >
        Log in
      </Link>
    )}
    {isLoggedIn && <Profile key="profile" product={product} />}
  </div>
);

export default enhance(LoginStatus);
